import React from "react";
import { RichText } from "prismic-reactjs";
import NotFound from "../NotFound";
import Loader from "../Loader";
import Speakers from "../slices/Speakers";

export default class Conference extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      notFound: false,
      speakers: null
    };
    if (props.prismicCtx) {
      this.fetchPage(props);
    }
  }

  componentDidUpdate(prevProps) {
    // this.props.prismicCtx.toolbar();
    if (!prevProps.prismicCtx) {
      this.fetchPage(this.props);
    }
  }

  fetchPage(props) {
    // We are using the function to get single type document
    return props.prismicCtx.api.getSingle("conference").then(doc => {
      if (doc) {
        // We put the retrieved content in the state as a doc variable

        const speakers = doc.data.body.find(
          item => item.slice_type === "speakers"
        );

        this.setState({ doc, speakers });
      } else {
        // We changed the state to display error not found if no matched doc
        this.setState({ notFound: !doc });
      }
    });
  }

  render() {
    if (this.state.doc) {
      const doc = this.state.doc;

      return (
        <div>
          <div className="conference hero-unit d-flex align-items-end pb-4">
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-6">
                  <h1 className="text-shadow mb-4 text-white">
                    {RichText.asText(doc.data.title)}
                  </h1>
                  <h2 className="text-shadow mb-4 text-white">
                    {RichText.asText(doc.data.subtitle)}
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="container pt-5 text-center">
            <div className="slogan">
              {RichText.render(
                doc.data.slogan,
                this.props.prismicCtx.linkResolver
              )}
            </div>
          </div>

          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-12 col-md-4 col-lg-5 order-md-last">
                <img
                  src={doc.data.main_image.url}
                  className="img-fluid mb-5 mb-md-0"
                  alt="conference"
                />
              </div>
              <div className="col-12 col-md-8 col-lg-7 order-md-first">
                <h2 className="text-uppercase text-blue">
                  {RichText.asText(doc.data.text_block[0].text_block_title)}
                </h2>
                <div className="content">
                  {RichText.render(
                    doc.data.text_block[0].text_block_content,
                    this.props.prismicCtx.linkResolver
                  )}
                </div>
              </div>
            </div>
          </div>

          <Speakers
            prismicCtx={this.props.prismicCtx}
            data={this.state.speakers}
          />

          <div className="container pt-5">
            <div className="row">
              <div className="col-12 col-md-8 col-lg-7 order-md-first">
                <h2 className="text-uppercase text-blue">
                  {RichText.asText(doc.data.text_block[1].text_block_title)}
                </h2>
                <div className="content">
                  {RichText.render(
                    doc.data.text_block[1].text_block_content,
                    this.props.prismicCtx.linkResolver
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-12 col-md-4">
                <img
                  src={doc.data.text_image_block[0].image_block.url}
                  className="img-fluid"
                  alt="block"
                />
              </div>
              <div className="col-12 col-md-8">
                <div className="text-block">
                  {RichText.render(
                    doc.data.text_image_block[0].rich_text_block,
                    this.props.prismicCtx.linkResolver
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Conference.js